import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerAddManualActivityMutation from './TrackerAddManualActivityMutation';
import TrackerQuery from '../Fetch/TrackerQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ITrackerAddManualActivityConnectorApolloProps {
  children: ({
    addManualActivity,
  }: {
    addManualActivity: (input: any) => Promise<any>;
  }) => React.ReactElement;
  post: any;
}

const TrackerAddManualActivityConnectorApollo: React.FC<
  ITrackerAddManualActivityConnectorApolloProps
> = ({ children, post }) => {
  const [addManualActivityMutation] = useMutation(TrackerAddManualActivityMutation);

  const addManualActivity = async (input: any) => {
    const date = formatIsoDate(new Date(input.dateTime));

    const response = await addManualActivityMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TrackerQuery,
          variables: {
            date,
          },
        },
      ],
    });

    if (post) {
      post('reload');
    }

    return response.data.dailyTracker.addManualActivity;
  };

  return children({ addManualActivity });
};

export default TrackerAddManualActivityConnectorApollo;
